import { Skeleton, Stack } from "@mui/material";

export default function () {
  return (
    <Stack spacing={2} marginTop={2} sx={{ px: { xs: 2, md: 0 } }}>
      {[...Array(10)]?.map(() => (
        <Stack direction="row" spacing={2} alignItems="center">
          {/* flexShrink is what made this an oval: the circle was squeezed narrower
              than its own height next to a 100%-wide sibling. Mobile also matches
              the card list's 36px avatar. */}
          <Skeleton variant="circular" sx={{ width: { xs: 36, md: 80 }, height: { xs: 36, md: 75 }, flexShrink: 0 }} />
          <Skeleton width="100%" />
        </Stack>
      ))}
    </Stack>
  );
}
